import { baseUrl } from '../../services/Apis';

export const getFilesArchivos = (file) => {
  return file
    ? `${baseUrl}/archivos/${file.folder}/public/${file.nombre}`
    : null;
};
